export const GET_FILTER_LIST = 'GET_FILTER_LIST'
